export default __webpack_public_path__ + "static/media/ic-tarjeta.39215bca.svg";